import * as React from "react";
import { Reveal, Overline } from "./primitives";
import { HEATHER_DOMI_TEAM_METRICS } from "@/data/approvedAgentProfile";

/**
 * Static Heather Domi Team credibility — approved marketing metrics only.
 * Never AI-generated. Clearly attributed to the team, not Alain personally.
 */
export const TeamCredibility: React.FC = () => {
  return (
    <section
      className="relative w-full overflow-hidden bg-charcoal py-20 md:py-28"
      data-testid="team-credibility"
      aria-label="Heather Domi Team — Trust in Numbers"
    >
      <div className="absolute inset-0 grain-overlay opacity-[0.07]" />
      <div className="relative mx-auto w-full max-w-4xl px-6 md:px-10">
        <Reveal>
          <Overline className="text-brass">Heather Domi Team</Overline>
          <h2 className="mt-4 font-serif text-3xl leading-tight text-ivory md:text-5xl">
            Trust in Numbers
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-ivory/65 md:text-base">
            Team-level credentials. These figures reflect the Heather Domi Team —
            not any individual agent’s personal production.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-2">
          {HEATHER_DOMI_TEAM_METRICS.map((m, i) => (
            <Reveal key={m.value} delay={0.05 * i}>
              <div className="break-inside-avoid" data-pdf-keep>
                <p className="font-serif text-4xl leading-none text-ivory md:text-5xl">
                  {m.value}
                </p>
                <p className="mt-4 max-w-xs text-[0.7rem] uppercase tracking-[0.18em] text-ivory/55">
                  {m.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
